import React from "react";
import defaultIconSettings from "./defaultIconSettings";

const TriangleIcon = ({
    color = defaultIconSettings.color,
    size = defaultIconSettings.size,
    className = defaultIconSettings.className,
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 384 323.3"
            style={{ height: size, width: size }}
            className={className}
        >
            <g>
                <path
                    fill={color}
                    d="M6 261.9c-7.8 12.4-8 28.1-.7 40.8 7.3 12.7 21 20.6 35.9 20.6h301.7c14.9 0 28.6-7.9 35.9-20.6 7.3-12.7 6.9-28.4-.8-40.8L227.2 19.4C219.7 7.3 206.4 0 192 0s-27.6 7.3-35.1 19.4L6 261.9z"
                />
            </g>
        </svg>
    );
};

export default TriangleIcon;
